module.exports = __webpack_public_path__ + "img/1477770698.048e605a.jpg";